import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  bulkEditInputSchema,
  bulkEditResultSchema,
  connectApiKeyInputSchema,
  connectOAuthInputSchema,
  connectSmtpInputSchema,
  countSchema,
  emptyInputSchema,
  importCsvInputSchema,
  importResultSchema,
  moveSendersInputSchema,
  senderIdInputSchema,
  senderIdsInputSchema,
  senderListSchema,
  senderSchema,
  testConnectionInputSchema,
  testOutcomeSchema,
  updateSenderInputSchema,
  updateWarmupInputSchema,
  warmupStatsSchema,
} from "./sender.schemas.ts";

export const senderTrpcContract = defineTrpcContract("sender", {
  list: query({ input: emptyInputSchema, output: senderListSchema }),
  get: query({ input: senderIdInputSchema, output: senderSchema }),
  warmupStats: query({ input: senderIdInputSchema, output: warmupStatsSchema }),
  connectOAuth: mutation({ input: connectOAuthInputSchema, output: senderSchema }),
  connectApiKey: mutation({ input: connectApiKeyInputSchema, output: senderSchema }),
  connectSmtp: mutation({ input: connectSmtpInputSchema, output: senderSchema }),
  testConnection: mutation({ input: testConnectionInputSchema, output: testOutcomeSchema }),
  update: mutation({ input: updateSenderInputSchema, output: senderSchema }),
  updateWarmup: mutation({ input: updateWarmupInputSchema, output: senderSchema }),
  refresh: mutation({ input: emptyInputSchema, output: countSchema }),
  bulkEdit: mutation({ input: bulkEditInputSchema, output: bulkEditResultSchema }),
  importCsv: mutation({ input: importCsvInputSchema, output: importResultSchema }),
  remove: mutation({ input: senderIdsInputSchema, output: countSchema }),
  moveToProject: mutation({ input: moveSendersInputSchema, output: countSchema }),
});
